import { saveAs } from 'file-saver';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl, FormControl } from '@angular/forms';
import { DadosPessoaisAba1Response } from 'app/auth/_models/DadosPessoaisAba1';
import { ToastrService } from 'ngx-toastr';
import { ConselhoAba13Service } from 'app/service/conselho-aba-13/conselho-aba-13.service';
import { EnumConselho } from 'app/model/enumConselho';
import { ParticipacaoConselhoDto } from "./ParticipacaoConselho.dto";
import { ParticipacaoConselhoRequestDto } from "./ParticipacaoConselhoRequest.dto";
import * as moment from "moment/moment";
import { DocumentosPessoaisDto } from "../recadastramento-aba3/documentosPessoais.dto";

function primeiraLetraMaiusculaValidator(): ValidatorFn {
  return (control: FormControl): { [key: string]: any } | null => {
    const valor = control.value;

    if (valor && valor.length > 0) {
      const primeiraLetra = valor.charAt(0);
      if (primeiraLetra !== primeiraLetra.toUpperCase()) {
        return { primeiraLetraMaiuscula: true };
      }
    }
    return null;
  };
}

function primeiraLetraMaiusculaValidatorOrgao(): ValidatorFn {
  return (control: FormControl): { [key: string]: any } | null => {
    const valor = control.value;

    if (valor && valor.length > 0) {
      // Adicione a validação para acentuação, números e caracteres especiais
      const pattern = /^[A-Za-z\s]*$/;
      if (!pattern.test(valor)) {
        return { noAccent: true };
      }

      const primeiraLetra = valor.charAt(0);
      if (primeiraLetra !== primeiraLetra.toUpperCase()) {
        return { primeiraLetraMaiuscula: true };
      }
    }
    return null;
  };
}

@Component({
  selector: 'app-recadastramento-aba13',
  templateUrl: './recadastramento-aba13.component.html',
  styleUrls: ['./recadastramento-aba13.component.sass']
})
export class RecadastramentoAba13Component implements OnInit {

  @Input() dadosPessoaisUser: any;
  @Input() mostrarAlerta: any;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();
  @Output() formularioSalvo = new EventEmitter<void>();
  @ViewChild('fileInputConselho') fileInputConselho!: ElementRef;

  formParticipacaoConselho: FormGroup;
  user: DadosPessoaisAba1Response = null;

  isLoading: boolean = true;
  isInfoImportantVisible: boolean = true;
  isLoadingSpinner: boolean = false
  anexoArquivoEnviado: boolean = false;
  arquivoSelecionadoConselho: File;
  arquivoEnviadoConselho: boolean = false;
  enviandoAnexoConselho: boolean = false;
  existeAnexoConselho: boolean = false;
  listaFormaParticipacao: EnumConselho[];
  listaOrigemParticipacao: EnumConselho[];
  listaTipoParticipacao: EnumConselho[];
  isAnexoConselho: boolean = false;
  participacaoConselho: ParticipacaoConselhoDto;

  flDiff: boolean;
  flDiffDisabledInputAnexo: boolean = true;
  isAnexoConselhoConst: boolean;

  initCamposVazios: boolean;
  flDatasInvalidas: boolean;
  isUpdatingFields: boolean = false;
  isCamposRequired: boolean;
  constructor(
    private toasterService: ToastrService,
    private formBuilder: FormBuilder,
    private conselhoAba13Service: ConselhoAba13Service
  ) {

    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));
    this.formParticipacaoConselho = this.formBuilder.group({
      nomeConselhoAssemelhado: [null, [this.checkPattern, primeiraLetraMaiusculaValidator()]],

      dataMandatoInicio: [null],
      dataMandatoFim: [null],
      idFormaParticipacao: [null],
      idOrigem: [null],
      idTipoParticipacao: [null],
      leiNormaAtoCriacao: [null],
      funcao: [null],
    });

    // Adicione as validações aos campos nomeConselhoAssemelhado e nomeOrgaoVinculado
    this.formParticipacaoConselho.get('nomeConselhoAssemelhado').setValidators([this.checkPatternConselho, primeiraLetraMaiusculaValidator()]);
    this.formParticipacaoConselho.get('nomeConselhoAssemelhado').updateValueAndValidity();

    Object.keys(this.formParticipacaoConselho.controls).forEach(key => {
      this.formParticipacaoConselho.get(key)?.valueChanges.subscribe(() => {
        this.updateRequiredFields();
      });
    });
  }

  checkPattern(control: FormControl): { [key: string]: any } | null {
    const value = control.value;

    if (value && value.trim() !== '') {
      const pattern = /^[A-Za-z\s]*$/;
      if (!pattern.test(value)) {
        return { noAccent: true };
      }
    }

    return null;
  }
  updateRequiredFields() {
    if (this.isUpdatingFields) {
      // Já estamos atualizando os campos, saia para evitar recursão infinita
      return;
    }

    this.isUpdatingFields = true;

    // Verificar se há valor em pelo menos um dos campos
    const anyFieldHasValue = Object.keys(this.formParticipacaoConselho.controls).some(key => {
      const control = this.formParticipacaoConselho.get(key);
      const fieldValue = control?.value;

      return fieldValue !== null && fieldValue !== '' && fieldValue !== undefined;
    });

    // Atualizar as validações de todos os campos
    Object.keys(this.formParticipacaoConselho.controls).forEach(key => {
      const control = this.formParticipacaoConselho.get(key);

      // Limpar validadores existentes
      control?.clearValidators();

      // Aplicar a validação de required em todos os campos se houver valor em pelo menos um deles


      if (anyFieldHasValue) {
        control?.setValidators([
          Validators.required,
        ]);
        this.isCamposRequired = true
        this.isAnexoConselho = true
        this.anexoArquivoEnviado = true
        this.flDiffDisabledInputAnexo = false
      }else {
        this.isCamposRequired = false
        this.isAnexoConselho = false
        this.anexoArquivoEnviado = false
      }

      // Adicionar a validação de checkPattern e primeiraLetraMaiusculaValidatorOrgao apenas nos campos específicos
      if (key === 'nomeConselhoAssemelhado') {
        control?.setValidators([
          ...control?.validator ? [control.validator] : [],
          this.checkPattern,
          primeiraLetraMaiusculaValidator(),
          Validators.minLength(3)
        ]);
      }

      // Atualizar o status de validação do controle
      control?.updateValueAndValidity();
    });

    this.isUpdatingFields = false;
  }




  ngOnInit(): void {
    this.getListaFormasParticipacao();
    this.getListaTipoParticipacao();
    this.getListaOrigemParticipacao();
    this.getParticipacaoConselho();
  }

  capitalizarPrimeiraLetra() {
    const nomeControl = this.formParticipacaoConselho.get('nomeConselhoAssemelhado');

    let valor = nomeControl.value;
    if (valor && valor.length > 0) {
      valor = valor.charAt(0).toUpperCase() + valor.slice(1);
      nomeControl.setValue(valor, { emitEvent: false });
    }

  }

  noAccentValidator(control: FormControl) {
    const value = control.value;

    if (value && /[áàãâäéèẽêëíìĩîïóòõôöúùũûü]/i.test(value)) {
      return { noAccent: true };
    }

    return null;
  }
  checkPatternConselho(control: FormControl): { [key: string]: any } | null {
    const value = control.value;

    if (value && value.trim() !== '') {
      const pattern = /^[A-Za-z\s]*$/;
      if (!pattern.test(value)) {
        return { noAccent: true };
      }
    }

    return null;
  }

  checkPatternOrgao(control: FormControl): { [key: string]: any } | null {
    const value = control.value;

    if (value && value.trim() !== '') {
      const pattern = /^[A-Za-z\s]*$/;
      if (!pattern.test(value)) {
        return { noAccent: true };
      }
    }

    return null;
  }





  toggleInfoImportantVisible() {
    this.isInfoImportantVisible = !this.isInfoImportantVisible;
  }

  normalizeData(documentSubmit: ParticipacaoConselhoRequestDto) {
    documentSubmit.mandatoInicio == "Invalid date" ? documentSubmit.mandatoInicio = null : false;
    documentSubmit.mandatoFim == "Invalid date" ? documentSubmit.mandatoFim = null : false;
  }

  atualizarParticipacaoConselho() {

    let participacao = new ParticipacaoConselhoRequestDto();
    let raw: ParticipacaoConselhoDto = this.formParticipacaoConselho.getRawValue();
    participacao.idTipoParticipacao = raw.idTipoParticipacao;
    participacao.idFormaParticipacao = raw.idFormaParticipacao;
    participacao.funcao = raw.funcao;
    participacao.nomeConselho = raw.nomeConselhoAssemelhado == '' ? null: raw.nomeConselhoAssemelhado ;
    participacao.leiAtoNormaCriacao = raw.leiNormaAtoCriacao;
    participacao.idOrigem = raw.idOrigem;
    participacao.mandatoInicio = moment(this.formParticipacaoConselho.controls['dataMandatoInicio'].value).format('DD/MM/YYYY');
    participacao.mandatoFim = moment(this.formParticipacaoConselho.controls['dataMandatoFim'].value).format('DD/MM/YYYY');
    this.normalizeData(participacao);


    if (!this.isAnexoConselho && this.isCamposRequired && !this.arquivoEnviadoConselho) {
      this.toasterService.warning("Por favor, anexe o comprovante para salvar");
      return
    }
    if (this.flDiff && this.arquivoSelecionadoConselho && this.formParticipacaoConselho.valid && !this.flDatasInvalidas) {
      this.conselhoAba13Service.salvarParticipacaoConselho(participacao).subscribe(resp => {
        this.getParticipacaoConselho();
        this.isAnexoConselho = true
        this.toasterService.success('Dados atualizados com sucesso');
        this.avancaParaProximoTab();
        this.anexoArquivoEnviado = false

      });
    } else if (this.flDiff && !this.arquivoSelecionadoConselho) {
      this.anexoArquivoEnviado = true
      this.toasterService.warning("Por favor, anexe o comprovante para salvar");
    } else if (!this.flDiff) {
      this.conselhoAba13Service.salvarParticipacaoConselho(participacao).subscribe(resp => {
        this.toasterService.success('Dados atualizados com sucesso');
        this.avancaParaProximoTab()
      });
    }

  }

  onArquivoExcluidoConselho(mensagem) {
    this.arquivoEnviadoConselho = false
    this.isAnexoConselho = false
    this.flDiffDisabledInputAnexo = false
    this.anexoArquivoEnviado = true
  }

  enviarAnexoConselho() {
    this.enviandoAnexoConselho = true
    if (this.arquivoSelecionadoConselho) {
      this.toasterService.info('Enviando arquivo. Por favor, aguarde.', '', {
        timeOut: 1000, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
      });
      this.conselhoAba13Service.uploadComprovante(this.arquivoSelecionadoConselho).subscribe(
        (response) => {
          this.isAnexoConselho = true
          this.toasterService.success('Arquivo enviado', '', {
            timeOut: 1500, // Ajuste o tempo em milissegundos (por exemplo, 2000ms = 2 segundos)
          });
          this.arquivoEnviadoConselho = true
          this.enviandoAnexoConselho = false
          this.fileInputConselho.nativeElement.value = '';
        },
        (error) => {
          this.fileInputConselho.nativeElement.value = '';
          this.arquivoEnviadoConselho = false
          if (error.status == 422) {
            this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
          } else {
            this.toasterService.error(`Erro ao enviar o anexo: ${error.error.message}`);
          }
          this.onArquivoExcluidoConselho(false)

        }
      );
    }
  }

  onArquivoSelecionado(event: any, TipoDocumento: string) {
    const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const maxFileSizeInBytes = 1024 * 1024 * 10; // 10 MB
    const file = event.target.files[0];

    if (file && allowedFileTypes.includes(file.type) && file.size <= maxFileSizeInBytes) {
      this.arquivoSelecionadoConselho = file;
      this.enviarAnexoConselho();
    }
    else {
      this.arquivoSelecionadoConselho = null;

      if (!allowedFileTypes.includes(file.type)) {
        this.toasterService.warning('Tipo de arquivo inválido! Apenas arquivos JPG, JPEG, PNG e PDF são permitidos.');
      } else if (file.size > maxFileSizeInBytes) {
        this.toasterService.warning('O arquivo anexado excede o tamanho máximo permitido de 10 MB.');
      }
      this.onArquivoExcluidoConselho(false)
    }

  }

  visualizarComprovanteConselho(): void {
    this.conselhoAba13Service.visualizarComprovante().subscribe((response: Blob) => {
      const fileName = 'Comprovante_Conselho';
      const fileType = this.getFileTypeFromBlob(response);
      if (fileType === null) {
        return;
      }

      const blob = new Blob([response], { type: fileType });
      // Inicia o download do arquivo
      saveAs(blob, fileName + '.' + fileType);
    }, error => {
      this.toasterService.warning('Erro ao fazer o download do arquivo');
    });
  }

  private getFileTypeFromBlob(blob: Blob): string | null {
    if (blob.type) {
      const contentType = blob.type.toLowerCase();
      if (contentType.includes('pdf')) {
        return 'pdf';
      } else if (contentType.includes('jpeg') || contentType.includes('jpg')) {
        return 'jpeg';
      } else if (contentType.includes('png')) {
        return 'png';
      }
    }
    return null;
  }

  extractFileName(contentDispositionHeader: string): string {
    const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = fileNameRegex.exec(contentDispositionHeader);
    if (matches != null && matches[1]) {
      return matches[1].replace(/['"]/g, '');
    }
    return '';
  }

  extractFileExtension(fileName: string): string {
    const fileExtensionRegex = /(?:\.([^.]+))?$/;
    const matches = fileExtensionRegex.exec(fileName);
    if (matches != null && matches[1]) {
      return matches[1].toLowerCase();
    }
    return '';
  }

  avancaParaProximoTab() {
    this.dadosSalvos.emit()
  }

  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }

  getListaFormasParticipacao() {
    this.conselhoAba13Service.getFormaParticipacao().subscribe((dados) => {
      this.listaFormaParticipacao = dados;
    });
  }

  getListaOrigemParticipacao() {
    this.conselhoAba13Service.getOrigemParticipacao().subscribe((dados) => {
      this.listaOrigemParticipacao = dados;
    });
  }

  getParticipacaoConselho() {
    this.conselhoAba13Service.getParticipacaoConselho().subscribe((dados) => {
      this.participacaoConselho = dados;
      if (this.participacaoConselho) {
        this.formParticipacaoConselho.patchValue(this.participacaoConselho);
        this.participacaoConselho.anexo ? this.arquivoEnviadoConselho = true : this.arquivoEnviadoConselho = false;
        this.participacaoConselho.anexo ? this.isAnexoConselho = true : this.isAnexoConselho = false;
        this.participacaoConselho.anexo ? this.isAnexoConselhoConst = true : this.isAnexoConselhoConst = false;

        this.participacaoConselho.anexo ? this.flDiffDisabledInputAnexo = false : this.flDiffDisabledInputAnexo = true;


        let dataMandatoInicio = this.participacaoConselho.dataMandatoInicio !== null ? this.participacaoConselho.dataMandatoInicio.split('/') : '';
        let dataMandatoFim = this.participacaoConselho.dataMandatoFim !== null ? this.participacaoConselho.dataMandatoFim.split('/') : '';

        dataMandatoInicio !== '' ? this.formParticipacaoConselho.patchValue({ dataMandatoInicio: new Date(+dataMandatoInicio[2], +dataMandatoInicio[1] - 1, +dataMandatoInicio[0]) }) : false;
        dataMandatoFim !== '' ? this.formParticipacaoConselho.patchValue({ dataMandatoFim: new Date(+dataMandatoFim[2], +dataMandatoFim[1] - 1, +dataMandatoFim[0]) }) : false;

        if(this.participacaoConselho.dadosSRh){
          this.formParticipacaoConselho.get('nomeConselhoAssemelhado').disable();
          this.formParticipacaoConselho.get('idTipoParticipacao').disable();
          this.formParticipacaoConselho.get('idFormaParticipacao').disable();
          this.formParticipacaoConselho.get('funcao').disable();
          this.formParticipacaoConselho.get('leiNormaAtoCriacao').disable();
          this.formParticipacaoConselho.get('idOrigem').disable();
          this.formParticipacaoConselho.get('dataMandatoInicio').disable();
        }
      } else {
        this.initCamposVazios = true;
      }
    });
  }

  getListaTipoParticipacao() {
    this.conselhoAba13Service.getTipoParticipacao().subscribe((dados) => {
      this.listaTipoParticipacao = dados;
    });
  }

  checkDiff() {
    const nomeConselhoAssemelhadoValue = this.formParticipacaoConselho.get('nomeConselhoAssemelhado').value;
    const nomeConselhoAssemelhado = nomeConselhoAssemelhadoValue === '' ? null : nomeConselhoAssemelhadoValue;


    const dataMandatoInicioValue = this.formParticipacaoConselho.get('dataMandatoInicio').value;
    const dataMandatoInicio = dataMandatoInicioValue === 'Invalid date' ? null : dataMandatoInicioValue;

    const dataMandatoFimValue = this.formParticipacaoConselho.get('dataMandatoFim').value;
    const dataMandatoFim = dataMandatoFimValue === 'Invalid date' ? null : dataMandatoFimValue;

    const leiNormaAtoCriacaoValue = this.formParticipacaoConselho.get('leiNormaAtoCriacao').value;
    const leiNormaAtoCriacao = leiNormaAtoCriacaoValue === 'Valor inválido' ? null : leiNormaAtoCriacaoValue;

    const funcaoValue = this.formParticipacaoConselho.get('funcao').value;
    const funcao = funcaoValue === 'Valor inválido' ? null : funcaoValue;

    const idOrigemValue = this.formParticipacaoConselho.get('idOrigem').value;
    const idOrigem = idOrigemValue === 'Valor inválido' ? null : idOrigemValue;

    const idTipoParticipacaoValue = this.formParticipacaoConselho.get('idTipoParticipacao').value;
    const idTipoParticipacao = idTipoParticipacaoValue === 'Valor inválido' ? null : idTipoParticipacaoValue;

    const idFormaParticipacaoValue = this.formParticipacaoConselho.get('idFormaParticipacao').value;
    const idFormaParticipacao = idFormaParticipacaoValue === 'Valor inválido' ? null : idFormaParticipacaoValue;

    if (this.formParticipacaoConselho.value.dataMandatoFim < this.formParticipacaoConselho.value.dataMandatoInicio && this.formParticipacaoConselho.value.dataMandatoFim != '' && this.formParticipacaoConselho.value.dataMandatoFim != null) {
      this.toasterService.warning("Data de inicio maior que data fim.")
      this.formParticipacaoConselho.controls.dataMandatoFim.reset()
      this.flDatasInvalidas = true;
    } else {
      this.flDatasInvalidas = false;
    }
    const dataFormatadaInicio = dataMandatoInicio ? formatDateToDDMMYYYY(new Date(dataMandatoInicio)) : null;

    const dataFormatada = dataMandatoFim ? formatDateToDDMMYYYY(new Date(dataMandatoFim)) : null;



    // const dataFormatada = this.formParticipacaoConselho.get('dataMandatoInicio').value.format('DD/MM/YYYY');
    // const dataFormatadaFim = this.formParticipacaoConselho.get('dataMandatoFim').value.format('DD/MM/YYYY');


    if (this.participacaoConselho.nomeConselhoAssemelhado !== nomeConselhoAssemelhado ||
      this.participacaoConselho.dataMandatoInicio !== dataFormatadaInicio ||
      this.participacaoConselho.dataMandatoFim !== dataFormatada ||
      this.participacaoConselho.leiNormaAtoCriacao !== (leiNormaAtoCriacao != '' ? leiNormaAtoCriacao : null) ||
      this.participacaoConselho.funcao !== (funcao != '' ? funcao: null) ||
      this.participacaoConselho.idOrigem !== (idOrigem != undefined ? idOrigem : null) ||
      this.participacaoConselho.idTipoParticipacao !== (idTipoParticipacao != undefined ? idTipoParticipacao : null) ||
      this.participacaoConselho.idFormaParticipacao !== (idFormaParticipacao != undefined ? idFormaParticipacao: null)) {

      this.flDiff = true;
      this.isAnexoConselho = false
      this.anexoArquivoEnviado = true
      this.flDiffDisabledInputAnexo = false
      if (!this.arquivoSelecionadoConselho) {
        this.arquivoEnviadoConselho = false;
        return true;
      } else {
        return false;
      }
    } else {
      this.flDiffDisabledInputAnexo = true
      this.isAnexoConselho = false

      this.flDiff = false;
      //this.flDiffDisabledInputAnexo = true;
      if(this.isAnexoConselhoConst && !this.isAnexoConselho){
          this.arquivoEnviadoConselho = true
          this.isAnexoConselho = false
      }
      return false;
    }
  }

}
function formatDateToDDMMYYYY(date) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}
